import { ArrowRightOutlined } from '@ant-design/icons';
import { usePostFrontTipiDomandaIdPraticaIdRichieste } from '@framework/api-client/api/inquiries-compile/domande-controller/domande-controller.ts';
import { getNetworkErrorMessage } from '@framework/ui/core/errors/getNetworkErrorMessage.tsx';
import {
  generatePath,
  useHistory,
} from '@framework/ui/core/router/TypedRoute.tsx';
import { Button, message, Tooltip } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export interface IStartSecondaryInquiryButtonProps {
  procedureDossierId: string | null | undefined;
  inquiryId: string | null | undefined;
  disabled?: boolean;
  tooltip?: string;
}

/**
 * Pulsante per l'avvio di una domanda secondaria collegata
 * a una pratica.
 */
export function StartSecondaryInquiryButton(
  props: IStartSecondaryInquiryButtonProps,
) {
  const { procedureDossierId, inquiryId, disabled, tooltip } = props;

  const { t } = useTranslation();

  const history = useHistory();

  const startInquiryMutation = usePostFrontTipiDomandaIdPraticaIdRichieste();

  const handleClick = useCallback(async () => {
    if (!procedureDossierId || !inquiryId) {
      // biome-ignore format: <tbd>
      message.error(t('pratiche.avvio-domande-secondarie.error-no-params', 'Errore durante l\'avvio della domanda. Parametri mancanti'));
      // biome-ignore format: <tbd>
      console.error(`Errore durante l'avvio della domanda. Parametri mancanti: "${procedureDossierId}", "${inquiryId}"`);
      return;
    }
    try {
      const result = await startInquiryMutation.mutateAsync({
        idIstanzaProcedimento: procedureDossierId,
        idTipoDomanda: inquiryId,
        data: { collegamenti: [] },
      });

      if (!result.id) {
        // biome-ignore format: <tbd>
        console.error(`Errore durante l'avvio della domanda. Nessun ID: ${result.id}`, { result });
        // biome-ignore format: <tbd>
        message.error(t('pratiche.avvio-domande-secondarie.error-no-id', 'Errore durante l\'avvio della domanda. Riprovare'));
        return;
      }

      // biome-ignore format: <tbd>
      message.success(t('pratiche.avvio-domande-secondarie.success', 'Domanda avviata con successo'));

      history.push(generatePath('/richieste/:id', { id: result.id }));
    } catch (e) {
      console.error(e);
      message.error(getNetworkErrorMessage(e));
    }
  }, [history, inquiryId, procedureDossierId, startInquiryMutation, t]);

  return (
    <Tooltip title={tooltip}>
      <Button
        type="primary"
        size="large"
        onClick={handleClick}
        loading={startInquiryMutation.isLoading}
        disabled={disabled}
      >
        {t('pratiche.domande.avvia-domanda-secondaria', 'Vai alla Domanda')}
        <ArrowRightOutlined aria-hidden />
      </Button>
    </Tooltip>
  );
}
